// Generated by ReScript, PLEASE EDIT WITH CARE


function fromString(version) {
  switch (version) {
    case "beta" :
        return /* BETA */0;
    case "final" :
        return /* FINAL */2;
    case "stable" :
        return /* STABLE */1;
    default:
      return /* STABLE */1;
  }
}

export {
  fromString ,
  
}
/* No side effect */
